__turbopack_context__.v({
  "accommodationBlock": "Z9X71G_accommodationBlock",
  "accommodationInfo": "Z9X71G_accommodationInfo",
  "address": "Z9X71G_address",
  "button": "Z9X71G_button",
  "container": "Z9X71G_container",
  "image": "Z9X71G_image",
  "name": "Z9X71G_name",
});
